/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import PageConfig from '@msr/Common/PageConfig';
import RelatedContent from '@msr/components/Card/RelatedContent';
import MsrTopBanner from '@msr/components/HeaderBanner/MsrTopBanner';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import StructuredTextContent from '@msr/components/UI/StructuredTextContent';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const PowerOfMantra = ({ pageData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext, '', 'en']);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={''}
          lang={'en'}
        />
      )}
      <Box as="section" className="container-article" p="0" bg="#FFF7E9">
        <MsrTopBanner
          sectionContent={{
            title: pageData.title,
            style: 'default',
            mobileImages: pageData.heroImage,
            desktopImage: [pageData.heroImage]
          }}
        />
        <Box
          maxW="586px"
          mx="auto"
          py={{ base: '20px', md: '60px' }}
          px="15px"
          className="structured-content-dark"
        >
          {StructuredTextContent(pageData.body)}
        </Box>
        {pageData?.related_content && (
          <RelatedContent posts={pageData?.related_content} lang={'en'} />
        )}
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

// export const getStaticPaths = async () => {
//   const msrPaths = config.USE_LOCAL_URL
//     ? [
//       `/mahashivratri/shiva/power-of-mantra`
//     ]
//     : await getLandingPaths('L1', '/mahashivratri/shiva/power-of-mantra');
//   return {
//     paths: msrPaths,
//     fallback: false
//   };
// };

export const getStaticProps = async ({ preview, previewData }) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('IN', 'en'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('IN', 'en'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', '', `shiva/power-of-the-mantra`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      menuType: 'msrmainmenu',
    },
  };
};

export default PowerOfMantra;
